import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { decryptData, encryptData } from '@/utils/encryption';

const initialValues = {
  cart: {},
  cartItems: [],
  refetchCart: undefined,
};

const useCart = create(
  persist(
    (set) => ({
      ...initialValues,
      setCart: (cart) => set({ cart: cart, cartItems: cart?.items }),

      addItem: (newItem) =>
        set((state) => {
          // Check if the item already exists in the cart
          const existingItem = state.cartItems.find(
            (item) => item.item_id === newItem.item_id
          );
          const updatedCartItems = existingItem
            ? state.cartItems.map((item) =>
                item.item_id === newItem.item_id
                  ? { ...item, qty: newItem.qty } // Update quantity if item exists
                  : item
              )
            : [...state.cartItems, newItem]; // Add new item if it doesn't exist
          return { ...state, cartItems: updatedCartItems };
        }),
      updateItem: (itemId, newQty) =>
        set((state) => {
          // Update the quantity of the item in the cart
          const updatedCartItems = state.cartItems.map((item) => {
            if (item.item_id === itemId) {
              return { ...item, qty: newQty };
            }
            return item;
          });
          return { ...state, cartItems: updatedCartItems };
        }),
      removeItem: (itemId) =>
        set((state) => {
          // Remove the item from the cart
          const updatedCartItems = state.cartItems.filter(
            (item) => item.item_id !== itemId
          );
          return { ...state, cartItems: updatedCartItems };
        }),

      setRefetchCart: (refetchCart) => {
        set({ refetchCart });
      },

      resetCart: () =>
        set((state) => {
          return { ...initialValues, cartpopup: state.cartpopup };
        }),

      togglePopup: () =>
        set((state) => {
          return { ...state, cartpopup: !state.cartpopup };
        }),
    }),
    {
      name: 'cart',
      storage: {
        getItem: (name) => {
          const storedValue = localStorage.getItem(name);
          return storedValue ? decryptData(storedValue) : null;
        },
        setItem: (name, value) => {
          localStorage.setItem(name, encryptData(value));
        },
        removeItem: (name) => {
          localStorage.removeItem(name);
        },
      },
    }
  )
);

export default useCart;
